import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { RemotePhsPaccRepo } from '@repository/phs/pacc/PhsPaccRepo';
import { PaccGameResultVO } from '@domain/vo/phs/pacc/results/PaccGameResultVO';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { PaccSelfReportResultVO } from '@domain/vo/phs/pacc/results/PaccSelfReportResultVO';
import { PaccApplyTipVO } from '@domain/vo/phs/pacc/results/PaccApplyTipVO';
import { PaccVideoResultVO } from '@domain/vo/phs/pacc/results/PaccVideoResultVO';

const remotePhsPaccRepo = new RemotePhsPaccRepo();

export const phsPaccResultsKeys = ['phs', 'pacc', 'results'];

// 종합 응시 결과, 응시 과정별 결과
export const usePHSPACCResultsResult = (sn: number) => {
  return useQuery(
    [...phsPaccResultsKeys, 'result', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsResult(sn);
      return new PaccApplyResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultsGame = (sn: number) => {
  return useQuery(
    [...phsPaccResultsKeys, 'game', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsGame(sn);
      return new PaccGameResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultsSelfReport = (sn: number) => {
  return useQuery(
    [...phsPaccResultsKeys, 'selfReport', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsSelfReport(sn);
      return new PaccSelfReportResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultsTip = (sn: number) => {
  return useQuery(
    [...phsPaccResultsKeys, 'resultTip', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsTip(sn);
      return new PaccApplyTipVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultsVideo = (sn: number) => {
  return useQuery(
    [...phsPaccResultsKeys, 'video', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsVideo(sn);
      return new PaccVideoResultVO(data);
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultSelectMatching = (onSuccess?: () => void, onError?: (err: AxiosError) => void) => {
  return useMutation((applySn: number) => remotePhsPaccRepo.fetchPHSPACCResultsSelectMatching(applySn), {
    onSuccess,
    onError,
  });
};
